import Vue from 'vue';
import Vuex from 'vuex';
import {db, moment} from '../main'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    userDetails: {},
    users: [],
    currentlySelectedUser: null,
    tools: [],
  },
  mutations: {

    RETRIEVE_USER_DETAILS(state, payload) {
      console.log("RETRIEVE_USER_DETAILS payload", payload);
      Vue.set(state, 'userDetails', payload);
    },

    RETRIEVE_USERS(state, payload) {
      console.log("RETRIEVE_USERS payload", payload);
      Vue.set(state, 'users', payload);
    },

    SET_CURRENTLY_SELECTED_USER(state, payload) {
      console.log("SET_CURRENTLY_SELECTED_USER payload", payload);
      Vue.set(state, 'currentlySelectedUser', payload);
    },

    RETRIEVE_TOOLS(state, payload) {
      console.log("RETRIEVE_TOOLS payload", payload);
      Vue.set(state, 'tools', payload);
    },

    RESET_STORE(state) {
      console.log("RESET_STORE");
      Vue.set(state, "userDetails", {} );
      Vue.set(state, "users", {} );
    }

  },
  actions: {
    retrieveUserDetails(context) {
      let userData = sessionStorage.getItem("HRAM_user") ? JSON.parse(sessionStorage.getItem("HRAM_user")) : {};
      context.commit("RETRIEVE_USER_DETAILS", userData);
    },

    async retrieveUsers(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.users.length && !forceUpdate) {
        console.log("Users data already in store!");
        return;
      }

      await db.collection('users')
        .get()
        .then(querySnapshot => {
          let users = querySnapshot.docs.map(doc => doc.data())
          context.commit("RETRIEVE_USERS", users);
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error retrieving users: ', error)
        })
    },

    setCurrentlySelectedUser(context, data) {
      context.commit("SET_CURRENTLY_SELECTED_USER", data);
    },

    async retrieveTools(context, forceUpdate) {
      const _this = this

      // retrieve data only once or if update is forced
      if (_this.state.tools.length && !forceUpdate) {
        console.log("Tools data already in store!");
        return;
      }

      await db.collection('tools')
          .get()
          .then(querySnapshot => {
            let tools = querySnapshot.docs.map(doc => doc.data())
            context.commit("RETRIEVE_TOOLS", tools);
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error retrieving tools: ', error)
          })
    },

    resetStore(context){
      context.commit("RESET_STORE");
    },

  },
  getters: {
    getUserDetails: state => state.userDetails,
    getUsers: state => state.users,
    getCurrentlySelectedUser: state => state.currentlySelectedUser ? state.currentlySelectedUser : JSON.parse(sessionStorage.getItem('HRAM_user')).id,
    getTools: state => state.tools,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js